"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lodash = require("lodash");

var _AnnotatedSuggestionRow = _interopRequireDefault(require("./AnnotatedSuggestionRow"));

var _KeyedAutoCompleteInput = require("./KeyedAutoCompleteInput.styles");

var _displayModes = require("../../../constants/displayModes");

var _dropdown = require("../../../styles/2_commonComponentStyles/dropdown");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var KeyedAutoCompleteInput = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(KeyedAutoCompleteInput, _React$PureComponent);

  var _super = _createSuper(KeyedAutoCompleteInput);

  function KeyedAutoCompleteInput(props) {
    var _this;

    _classCallCheck(this, KeyedAutoCompleteInput);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onBlur", function () {
      _this.debounceBlur();
    });

    _defineProperty(_assertThisInitialized(_this), "focus", function () {
      _this.inputRef.focus();
    });

    _defineProperty(_assertThisInitialized(_this), "handleMouseDown", function (e) {
      if (_this.props.clickWillToggle) {
        _this.setState({
          clearList: !_this.state.clearList
        });
      }

      _this.props.onMouseDown(e);
    });

    _defineProperty(_assertThisInitialized(_this), "blur", function () {
      _this.inputRef.current.blur();
    });

    _defineProperty(_assertThisInitialized(_this), "focus", function () {
      _this.inputRef.current.focus();
    });

    _defineProperty(_assertThisInitialized(_this), "handleSuggestionSelect", function (_ref) {
      var primaryText = _ref.primaryText,
          suggestionId = _ref.suggestionId;
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          onSelectionIdChange = _this$props.onSelectionIdChange;

      _this.setState({
        clearList: true
      });

      onChange(primaryText);

      if (suggestionId) {
        onSelectionIdChange(suggestionId);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (e) {
      _this.setState({
        clearList: false,
        isLoading: true
      });

      _this.props.onChange(e.target.value);
    });

    _defineProperty(_assertThisInitialized(_this), "handleFocus", function () {
      if (_this.props.value.length >= _this.props.minimumAutocompleteChars) {
        _this.setState({
          clearList: false,
          selectedId: -1
        });
      }

      _this.props.onFocus();
    });

    _defineProperty(_assertThisInitialized(_this), "handleKeyDown", function (e) {
      var selectedId = _this.state.selectedId;
      var _this$props2 = _this.props,
          onChange = _this$props2.onChange,
          suggestions = _this$props2.suggestions,
          maxSuggestions = _this$props2.maxSuggestions;
      var max = maxSuggestions && Math.min(maxSuggestions, suggestions.suggestionItems.length) - 1; // Up Arrow

      if (e.keyCode === 38) {
        e.preventDefault();

        if (selectedId < 0) {
          _this.setState({
            selectedId: max
          });
        } else {
          _this.setState({
            selectedId: selectedId - 1
          });
        }
      } // Down Arrow


      if (e.keyCode === 40) {
        e.preventDefault();

        if (selectedId >= max) {
          _this.setState({
            selectedId: -1
          });
        } else {
          _this.setState({
            selectedId: selectedId + 1,
            clearList: false
          });
        }
      } // Enter


      if (e.keyCode === 13 && selectedId > -1 && _this.shouldShowSuggestions()) {
        e.preventDefault();
        var selected = _this.props.suggestions.suggestionItems[selectedId];

        _this.setState({
          clearList: true,
          selectedId: -1
        });

        onChange(selected.primaryText);

        _this.props.onSelectionIdChange(selected.suggestionId);
      }

      _this.props.onKeyDown(e);
    });

    _defineProperty(_assertThisInitialized(_this), "handleGetAutocompleteSuggestions", function () {
      _this.setState({
        previousSearchValue: _this.props.value,
        selectedId: -1
      });

      _this.debounceAutocompleteSuggestions();
    });

    _defineProperty(_assertThisInitialized(_this), "validateInput", function () {
      return _this.inputRef.current && _this.inputRef.current.validateInput();
    });

    _this.state = {
      clearList: false,
      isLoading: false,
      previousSearchValue: null,
      selectedId: -1
    };
    _this.inputRef = _react.default.createRef(); // Use of this.props below is intentional. It grabs the props value when the
    // function is called rather than using the closure value from the time the
    // function was created.

    _this.debounceAutocompleteSuggestions = props._debounceOverwriteFn(function () {
      var _this$props3 = _this.props,
          value = _this$props3.value,
          getAutocompleteSuggestions = _this$props3.getAutocompleteSuggestions; // Please don't change, see above

      getAutocompleteSuggestions(value);
    }, _this.props.typeDelay); // Please don't change, see above

    _this.debounceBlur = _this.props._debounceOverwriteFn(function () {
      _this.props.onBlur();

      _this.setState({
        clearList: true
      });
    }, 300);
    return _this;
  }

  _createClass(KeyedAutoCompleteInput, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.value !== prevProps.value && this.props.value.length >= this.props.minimumAutocompleteChars) {
        if (this.state.clearList) {
          this.inputRef.current.validateInput();
        } else {
          this.handleGetAutocompleteSuggestions();
        }
      }

      if (this.props.suggestions.id !== prevProps.suggestions.id) {
        this.setState({
          isLoading: false
        }); // eslint-disable-line react/no-did-update-set-state
      }

      this.debounceBlur && this.debounceBlur.cancel(); // eslint-disable-line no-unused-expressions
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.debounceBlur.cancel();
    }
  }, {
    key: "buildSuggestionList",
    value: function buildSuggestionList() {
      var _this2 = this;

      var _this$props4 = this.props,
          colorTheme = _this$props4.colorTheme,
          inputName = _this$props4.inputName,
          maxSuggestions = _this$props4.maxSuggestions,
          attribution = _this$props4.attribution;
      var selectedId = this.state.selectedId;
      var suggestionItems = this.props.suggestions.suggestionItems;

      if (!suggestionItems.length) {
        return [];
      }

      var filteredSuggestions = suggestionItems.filter(function (suggestion, index) {
        return index < maxSuggestions;
      });
      var suggestionList = filteredSuggestions.slice(0, maxSuggestions + 1).map(function (suggestion, index) {
        return /*#__PURE__*/_react.default.createElement(_AnnotatedSuggestionRow.default, {
          active: index === selectedId,
          colorTheme: colorTheme,
          dataTestId: "keyed-auto-complete-suggestion-row",
          id: "".concat(inputName, "-").concat(index),
          key: suggestion.primaryText,
          onClick: _this2.handleSuggestionSelect,
          suggestion: suggestion
        });
      });

      if (attribution) {
        var attribItem = /*#__PURE__*/_react.default.createElement(_AnnotatedSuggestionRow.default, {
          attribution: attribution,
          colorTheme: colorTheme,
          dataTestId: "keyed-auto-complete-attribution-row",
          id: "".concat(inputName, "-attribution"),
          key: "attribution",
          onClick: function onClick() {},
          suggestion: {
            primaryText: ''
          }
        });

        suggestionList.push(attribItem);
      }

      return suggestionList;
    }
  }, {
    key: "shouldShowSuggestions",
    value: function shouldShowSuggestions(hasSuggestionsToShow) {
      var _this$props5 = this.props,
          forceShowList = _this$props5.forceShowList,
          minimumAutocompleteChars = _this$props5.minimumAutocompleteChars,
          value = _this$props5.value,
          allowEmpty = _this$props5.allowEmpty;
      var _this$state = this.state,
          clearList = _this$state.clearList,
          isLoading = _this$state.isLoading,
          previousSearchValue = _this$state.previousSearchValue;
      return forceShowList || !isLoading && (previousSearchValue || allowEmpty) && value.length >= minimumAutocompleteChars && !clearList && hasSuggestionsToShow;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
          autoFocus = _this$props6.autoFocus,
          autoComplete = _this$props6.autoComplete,
          characterLimit = _this$props6.characterLimit,
          className = _this$props6.className,
          colorTheme = _this$props6.colorTheme,
          dataTestId = _this$props6.dataTestId,
          disabled = _this$props6.disabled,
          displayName = _this$props6.displayName,
          errors = _this$props6.errors,
          inputName = _this$props6.inputName,
          leftIcons = _this$props6.leftIcons,
          mode = _this$props6.mode,
          rightIcons = _this$props6.rightIcons,
          validationRules = _this$props6.validationRules,
          value = _this$props6.value,
          label = _this$props6.label;
      var autocompleteSuggestions = this.buildSuggestionList();
      var showSuggestions = this.shouldShowSuggestions(!!autocompleteSuggestions.length);
      return /*#__PURE__*/_react.default.createElement(_KeyedAutoCompleteInput.StyledKeyedAutoCompleteInput, {
        className: className,
        "data-test-id": dataTestId
      }, /*#__PURE__*/_react.default.createElement(_KeyedAutoCompleteInput.StyledLabeledInput, {
        autoComplete: autoComplete,
        autoFocus: autoFocus,
        characterLimit: characterLimit,
        dataTestId: "keyed-auto-complete-input",
        disabled: disabled,
        displayName: displayName,
        errors: errors,
        id: inputName,
        label: label,
        leftIcons: leftIcons,
        mode: mode,
        name: inputName,
        onBlur: this.onBlur,
        onChange: this.handleChange,
        onFocus: this.handleFocus,
        onKeyDown: this.handleKeyDown,
        onMouseDown: this.handleMouseDown,
        ref: this.inputRef,
        rightIcons: rightIcons,
        validationRules: validationRules,
        value: value
      }), showSuggestions && /*#__PURE__*/_react.default.createElement(_KeyedAutoCompleteInput.StyledSuggestionsWrapper, {
        "data-test-id": "keyed-auto-complete-suggestions-wrapper",
        colorTheme: colorTheme,
        hasLabel: !!label
      }, autocompleteSuggestions));
    }
  }]);

  return KeyedAutoCompleteInput;
}(_react.default.PureComponent);

_defineProperty(KeyedAutoCompleteInput, "propTypes", {
  /** This lets the dropdown activate when there is nothing in the search area. Used for SelectList */
  allowEmpty: _propTypes.default.bool,

  /** attribution for autocomplete values from 3rd party services */
  attribution: _propTypes.default.func,

  /** set autoFocus on Input */
  autoFocus: _propTypes.default.bool,

  /** autoComplete */
  autoComplete: _propTypes.default.string,

  /** Character Limit */
  characterLimit: _propTypes.default.number,

  /** Styling Overwrite Hook */
  className: _propTypes.default.string,

  /** Controls whether clicks toggle the dropdown */
  clickWillToggle: _propTypes.default.bool,

  /** Color theme option - follows button-like options */
  colorTheme: _propTypes.default.oneOf(_dropdown.dropdownColorThemes),

  /** Test ID hook */
  dataTestId: _propTypes.default.string.isRequired,

  /** Flag used to disable the input */
  disabled: _propTypes.default.bool,

  /** text to be used in Error Messages */
  displayName: _propTypes.default.string,

  /** Flag used for indicating an error state for the input */
  errors: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.string), _propTypes.default.string]),

  /** Overrides list behavior to show list immediately */
  forceShowList: _propTypes.default.bool,

  /** name for input field (needed for validation rules to work */
  inputName: _propTypes.default.string,

  /** Optional Label for Keyed AutoComplete */
  label: _propTypes.default.string,

  /** Controls input validation */
  validationRules: _propTypes.default.objectOf(_propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]))),

  /** Get Autocomplete Suggestions hook */
  getAutocompleteSuggestions: _propTypes.default.func.isRequired,

  /** an array of icons to be passed to labeled input */
  leftIcons: _propTypes.default.arrayOf(_propTypes.default.element),

  /** Max Autocomplete Suggestions */
  maxSuggestions: _propTypes.default.number,

  /** Minimum Autocomplete Characters - Minimum number of characters before autocomplete calls are made */
  minimumAutocompleteChars: _propTypes.default.number,

  /** mode flag - 'viewOnly', 'viewing' or 'editOnly' */
  mode: _propTypes.default.oneOf([undefined, _displayModes.displayModes.viewOnly, _displayModes.displayModes.viewing, _displayModes.displayModes.editOnly]),

  /** onChange handler */
  onChange: _propTypes.default.func.isRequired,

  /** onBlur handler */
  onBlur: _propTypes.default.func,

  /** onFocus handler */
  onFocus: _propTypes.default.func,

  /** onMousedown handler */
  onMouseDown: _propTypes.default.func,

  /** onKeyDown handler */
  onKeyDown: _propTypes.default.func,

  /** onSelectionIdChange - handle changes to suggestion ID */
  onSelectionIdChange: _propTypes.default.func,

  /** an array of icons to be passed to labeled input */
  rightIcons: _propTypes.default.arrayOf(_propTypes.default.element),

  /** Array of autocomplete suggestions */
  suggestions: _propTypes.default.shape({
    suggestionItems: _propTypes.default.arrayOf(_propTypes.default.shape({
      primaryText: _propTypes.default.string.isRequired,
      suggestionId: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]).isRequired,
      secondaryText: _propTypes.default.string
    })).isRequired,
    id: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]).isRequired
  }).isRequired,

  /** Time in ms to wait after typing before sending autocomplete trigger */
  typeDelay: _propTypes.default.number,

  /** Value of the input */
  value: _propTypes.default.string.isRequired,

  /** Override for debounce */
  _debounceOverwriteFn: _propTypes.default.func
});

_defineProperty(KeyedAutoCompleteInput, "defaultProps", {
  allowEmpty: false,
  attribution: undefined,
  autoComplete: 'off',
  autoFocus: false,
  className: '',
  clickWillToggle: false,
  colorTheme: 'primary',
  _debounceOverwriteFn: _lodash.debounce,
  disabled: false,
  displayName: '',
  characterLimit: 80,
  errors: [],
  forceShowList: false,
  inputName: 'Input',
  label: '',
  leftIcons: [],
  validationRules: {},
  maxSuggestions: 5,
  minimumAutocompleteChars: 3,
  mode: _displayModes.displayModes.edit,
  onBlur: function onBlur() {},
  onFocus: function onFocus() {},
  onKeyDown: function onKeyDown() {},
  onMouseDown: function onMouseDown() {},
  onSelectionIdChange: function onSelectionIdChange() {},
  rightIcons: [],
  typeDelay: 500
});

var _default = KeyedAutoCompleteInput;
exports.default = _default;